import React from "react";
import Detail from "../atoms/carrersDetail";

const Details: React.FC = () => {
  return (
    <div className="h-[100svh] w-screen overflow-y-auto">
      <Detail />
    </div>
  );
};

export default Details;
